import { render, staticRenderFns } from "./KETWidgetDate.vue?vue&type=template&id=380921bb&"
import script from "./KETWidgetDate.vue?vue&type=script&lang=js&"
export * from "./KETWidgetDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports